import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthFormNotificationType } from '@shared/models/auth.interface';

@Component({
  selector: 'app-form-notification',
  templateUrl: './form-notification.component.html',
  styleUrls: ['./form-notification.component.scss']
})
export class FormNotificationComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  @Input() type: AuthFormNotificationType = 'ACCESSCODE_ERROR';

  readonly notificationMessage = new Map<AuthFormNotificationType, string>([
    ["LOGOUT", 'page.login.form.accessCode.logoutSuccessfulMessage'],
    ["LOGOUT_FORCEFULLY", 'page.login.form.accessCode.logoutForcefullyMessage'],
    ["UNKNOWN_ERROR", 'Unknown Error Occurred.'],
    ["ACCESS_DENIED", 'page.login.form.accessCode.accessDeniedMessage'],
    ["ACCESSCODE_ERROR", 'page.login.form.accessCode.invalidAccessCodeMessage'],
    ["LOGIN_ERROR", 'page.login.form.login.invalidLoginMessage'],
    ["USER_INACTIVE", 'page.login.form.login.userInactiveMessage'],
    ["USER_LOGIN_INACTIVE", 'page.login.form.login.userInactiveMessage'],
    ["USER_NOT_LINKED_WITH_CLIENTS", 'page.login.form.login.noClientsLinkedMessage'],
    ["LICENSE_ERROR", 'page.login.form.login.invalidLicenseMessage'],
    ["PORTAL_UNAVAILABLE", 'page.login.form.login.noPagesAvailableMessage'],
    ["PASS_RECOVERY_SUCCESS", 'page.login.form.passwordRecovery.recoverySuccessMessage'],
    ["PASS_RECOVERY_ERROR_WITH_EMAIL", 'page.login.form.passwordRecovery.recoveryFailureUsingEmailIDMessage'],
    ["PASS_RECOVERY_ERROR_WITH_USERNAME", 'page.login.form.passwordRecovery.recoveryFailureUsingUsernameMessage'],
    ["ADMIN_TYPE_LOCATION_DOES_NOT_HAVE_CHILDS", 'page.login.form.login.adminWithNoChildMessage'],
  ]);

  constructor() { }

  ngOnInit(): void {
  }

  applyClass() {
    return (this.type === "PASS_RECOVERY_SUCCESS" || this.type === "LOGOUT") ? 'SuccessMessage' : 'InvalidMessage';
  }

  closeNotification() {
    this.close.next(true);
  }
}
